// import {data} from "../Data";

import {  getAllAssistantUrl,  apiToken, baseBackendURL, assistantUrl } from "../config";

// to get all assistant
export const getAllAssistant = async (userOrgId) => {
  try {
    const url = userOrgId ? `${getAllAssistantUrl}?organizationId=${userOrgId}` : getAllAssistantUrl;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${apiToken}`
      }
    })
    if (!response.ok) {
      throw new Error('Network response was not ok')
    }
    const data = await response.json();
    return data;
  } catch (e) {
    console.error(e);
  }
}

// to get all assistant ended

// start assistant fetch external 

export const getAssistantFetchExternal = async (id) => {
  try {
    const getAssistantFetchUrl = `${baseBackendURL}assistants/${id}`;
    const response = await fetch(getAssistantFetchUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${apiToken}`
      }
    });
    const res = await response.json();
    if (!response.ok) {
      throw new Error(res.message || 'Network response is not ok');
    }
    return res;
  } catch(e) {
    throw new Error(e.message || "Fetch failed")
  }
}

// end assistant fetch external

// delete assistant start

export const deleteAssistantID = async (id) => {
  try {
    const deleteAssistantURL = `${assistantUrl}/${id}`;
    const response = await fetch(deleteAssistantURL, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${apiToken}`
      }
    })
    const res = await response.json();
    if (!response.ok) {
      throw new Error(res.message || 'Network response is not ok');
    }
    return res;
  } catch(e) {
    throw new Error(e.message || "Delete failed")
  }
}

// delete assistant end

export const updateAssistant = async (id, data) => {
  const updateAssistantURL = `${assistantUrl}/${id}`;


  try {


    const response = await fetch(updateAssistantURL, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${apiToken}`
      },
      body: JSON.stringify(data)
    });

    const res = await response.json();

    if (!response.ok) {
      console.error("Error response from server:", res);
      throw new Error(res.message || 'Failed to update assistant');
    }


    return res;

  } catch (error) {
    console.error("Update failed:", error);
    throw new Error(error.message || "Update failed");
  }
};


// update assistant end

// start add assistant

export const createAssistant = async (data) => {
  try {


    const response = await fetch(assistantUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiToken}`, 
      },
      body: JSON.stringify(data),
    });

    const res = await response.json();

    if (!response.ok) {
      throw new Error(res.message || 'Failed to create assistant');
    }

    return res;
  } catch (error) {
    throw new Error(error.message || 'Create request failed');
  }
};

/// start reassign organziation

export const reassignOrganization = async (assistantID, organizationId) => {
  try {
    const assistantReassignUrl = `${assistantUrl}/${assistantID}/assign-organization`;
    const response = await fetch(assistantReassignUrl, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${apiToken}`
      },
      body: JSON.stringify({ organizationId })
    });
    const res = await response.json();
    if (!response.ok) {
      throw new Error(res.message || 'Failed to reassign organization');
    } 
    return res;

  } catch(e) {
    throw new Error(e.message || "Reassign organization failed");
  }
}

// end reassign organization

// start get Assistant with oragnization id

export const getAssistantWithOrgId = async (orgId) => {
  try {
    const url = orgId ? `${assistantUrl}?organizationId=${orgId}` : assistantUrl;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${apiToken}`
      }
    });
    const res = await response.json();
    if (!response.ok) {
      throw new Error(res.message || 'Network response is not ok');
    }
    return res;
  } catch(e) {
    throw new Error(e.message || "Fetch failed")
  }
}